// extracted by mini-css-extract-plugin
module.exports = {"melodyRule":"ge"};